export const TenantManagementIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-factory-icon lucide-factory"
    >
      <path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
      <path d="M17 18h1" />
      <path d="M12 18h1" />
      <path d="M7 18h1" />
    </svg>
  );
};

export const ProcessManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="fi_2550640"
      viewBox="0 0 60 60"
      width="24"
      height="24"
    >
      <path d="M37.9,12.2a1,1,0,0,0,.546.771A18.922,18.922,0,0,1,48.975,29h-.73a2.236,2.236,0,0,0-1.7,3.7L51.3,38.219a2.245,2.245,0,0,0,3.4,0L59.456,32.7A2.236,2.236,0,0,0,57.755,29h-.774A26.944,26.944,0,0,0,42.463,6.054a1,1,0,0,0-.982.061A1.052,1.052,0,0,0,41,7a4.255,4.255,0,0,1-1.481,3.222l-1.281,1.1A1,1,0,0,0,37.9,12.2Zm2.926-.467a6.239,6.239,0,0,0,1.98-3.2A24.941,24.941,0,0,1,55,30a1,1,0,0,0,1,1h1.755a.229.229,0,0,1,.222.141.218.218,0,0,1-.037.25l-4.755,5.525a.216.216,0,0,1-.371,0L48.06,31.391a.218.218,0,0,1-.037-.25A.229.229,0,0,1,48.245,31H50a1,1,0,0,0,1-1A20.9,20.9,0,0,0,40.642,11.893Z"></path>
      <path d="M7,19a4.251,4.251,0,0,1,3.223,1.473l1.109,1.289a1,1,0,0,0,.758.348,1.046,1.046,0,0,0,.124-.008,1,1,0,0,0,.771-.547A18.886,18.886,0,0,1,29,11.026v.729a2.237,2.237,0,0,0,3.7,1.7L38.219,8.7a2.246,2.246,0,0,0,0-3.4L32.7.544A2.208,2.208,0,0,0,30.307.206,2.219,2.219,0,0,0,29,2.245v.773A26.949,26.949,0,0,0,6.054,17.537a1,1,0,0,0,.061.981A1.05,1.05,0,0,0,7,19ZM30,5a1,1,0,0,0,1-1V2.245a.229.229,0,0,1,.141-.222.221.221,0,0,1,.25.037l5.525,4.754a.247.247,0,0,1,0,.372L31.391,11.94a.219.219,0,0,1-.25.037A.229.229,0,0,1,31,11.755V10a1,1,0,0,0-1-1A20.869,20.869,0,0,0,11.9,19.357l-.163-.19h0a6.2,6.2,0,0,0-3.2-1.971A24.94,24.94,0,0,1,30,5Z"></path>
      <path d="M29.693,46.205a2.21,2.21,0,0,0-2.388.339L21.78,51.3a2.245,2.245,0,0,0,0,3.4L27.3,59.456a2.237,2.237,0,0,0,3.7-1.7v-.774A26.945,26.945,0,0,0,53.946,42.463a1.008,1.008,0,0,0-.061-.982A1.052,1.052,0,0,0,53,41a4.252,4.252,0,0,1-3.223-1.483l-1.1-1.279a1,1,0,0,0-1.654.2A18.923,18.923,0,0,1,31,48.975v-.73A2.221,2.221,0,0,0,29.693,46.205Zm18.413-5.563.155.179v0a6.246,6.246,0,0,0,3.2,1.98A24.943,24.943,0,0,1,30,55a1,1,0,0,0-1,1v1.755a.229.229,0,0,1-.141.222.221.221,0,0,1-.25-.037l-5.525-4.754a.248.248,0,0,1,0-.372L28.61,48.06a.223.223,0,0,1,.147-.06.252.252,0,0,1,.1.023.229.229,0,0,1,.141.222V50a1,1,0,0,0,1,1A20.9,20.9,0,0,0,48.106,40.642Z"></path>
      <path d="M2.245,31h.773A26.949,26.949,0,0,0,17.537,53.946a.9.9,0,0,0,.42.1,1.089,1.089,0,0,0,.561-.162A1.05,1.05,0,0,0,19,53a4.208,4.208,0,0,1,1.472-3.212l1.29-1.11a1,1,0,0,0-.206-1.653A18.917,18.917,0,0,1,11.026,31h.729a2.238,2.238,0,0,0,1.7-3.7L8.7,21.78A2.243,2.243,0,0,0,7,21H7a2.242,2.242,0,0,0-1.7.78L.544,27.3a2.238,2.238,0,0,0,1.7,3.7ZM2.06,28.609l4.755-5.525a.247.247,0,0,1,.371,0l4.754,5.525a.218.218,0,0,1,.037.25.229.229,0,0,1-.222.141H10a1,1,0,0,0-1,1A20.9,20.9,0,0,0,19.359,48.107l-.188.163a6.144,6.144,0,0,0-1.976,3.2A24.943,24.943,0,0,1,5,30a1,1,0,0,0-1-1H2.245a.229.229,0,0,1-.222-.141A.218.218,0,0,1,2.06,28.609Z"></path>
    </svg>
  );
};

export const AIMSPortalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-tag-icon lucide-tag"
    >
      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
      <circle
        cx="7.5"
        cy="7.5"
        r=".5"
        fill="currentColor"
      />
    </svg>
  );
};

export const HolidayCalendarIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="18"
        height="18"
        x="3"
        y="4"
        rx="2"
        ry="2"
      ></rect>
      <line
        x1="16"
        x2="16"
        y1="2"
        y2="6"
      ></line>
      <line
        x1="8"
        x2="8"
        y1="2"
        y2="6"
      ></line>
      <line
        x1="3"
        x2="21"
        y1="10"
        y2="10"
      ></line>
      <path d="M17 14h-6"></path>
      <path d="M13 18H7"></path>
      <path d="M7 14h.01"></path>
      <path d="M17 18h.01"></path>
    </svg>
  );
};

export const ProductManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        x="3"
        y="8"
        width="18"
        height="4"
        rx="1"
      />
      <path d="M12 8v13" />
      <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
      <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
    </svg>
  );
};

export const TeplarPrintTemplateManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5" />
      <path d="m16 19 2 2 4-4" />
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2" />
      <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
    </svg>
  );
};

export const KishuManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z" />
      <path d="M12 17.66L12 22" />
    </svg>
  );
};

export const ProcessTemplateManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="18"
        height="7"
        x="3"
        y="3"
        rx="1"
      />
      <rect
        width="7"
        height="7"
        x="3"
        y="14"
        rx="1"
      />
      <rect
        width="7"
        height="7"
        x="14"
        y="14"
        rx="1"
      />
    </svg>
  )
}

export const TrayManagementIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      stroke="currentColor"
      fill="none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        d="M12.8,1.8c2.2,0,2.9,0,4.3,0.2c1.4,0.2,2.6,0.6,3.5,1.5c0.9,0.9,1.3,2.1,1.5,3.5c0.2,1.2,0.2,3.1,0.2,5.1l0,1.5
	c0,1.7,0,3.2-0.3,4.3c-0.2,1.2-0.6,2.1-1.4,2.8c-0.9,0.9-2,1.2-3.3,1.4c-1.3,0.2-3.1,0.2-5.3,0.2h-0.1c-2.2,0-3.9,0-5.3-0.2
	c-1.4-0.2-2.5-0.6-3.3-1.4c-0.8-0.8-1.1-1.7-1.4-2.8c-0.2-1.1-0.2-2.5-0.3-4.3l0-1.5c0-2,0-3.9,0.2-5.1c0.2-1.4,0.6-2.6,1.5-3.5
	s2.1-1.3,3.5-1.5c1.4-0.2,3.1-0.2,5.3-0.2L12.8,1.8z M20.1,7.2c0.2,1.2,0.2,3.1,0.2,5.3c0,0.2-0.1,0.3-0.3,0.3h-3.4
	c-1.3,0-2.1,1-2.5,1.9c-0.3,0.6-0.9,1.1-2,1.1s-1.7-0.6-2-1.1c-0.4-0.8-1.3-1.9-2.5-1.9H4.1c-0.2,0-0.3-0.1-0.3-0.3
	c0-2.2,0-4.1,0.2-5.3C4.1,6,4.4,5.3,4.8,4.8S6,4.1,7.2,3.9c1.2-0.2,3.3-0.2,5.6-0.2c2.3,0,2.9,0,4.1,0.2c1.2,0.2,1.8,0.5,2.3,0.9
	C19.6,5.3,19.9,6,20.1,7.2z"
      />
    </svg>
  )
}
export const TrayTagReassignmentIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5" /><path d="M12 10v4h4" /><path d="m12 14 1.535-1.605a5 5 0 0 1 8 1.5" /><path d="M22 22v-4h-4" /><path d="m22 18-1.535 1.605a5 5 0 0 1-8-1.5" /></svg>

  )
}
export const GroupManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <path d="M16 3.128a4 4 0 0 1 0 7.744" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <circle
        cx="9"
        cy="7"
        r="4"
      />
    </svg>
  )
}

export const UserLogsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M15 12h-5" />
      <path d="M15 8h-5" />
      <path d="M19 17V5a2 2 0 0 0-2-2H4" />
      <path d="M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3" />
    </svg>
  )
}

export const ActiveTrayManagementIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      stroke="currentColor"
      fill="none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g>
        <path
          d="M18,1.2c-2.6,0-4.8,2.1-4.8,4.8s2.1,4.8,4.8,4.8s4.8-2.1,4.8-4.8S20.6,1.2,18,1.2z M19.7,5.3
		c0.4-0.2,0.5-0.7,0.3-1c-0.2-0.4-0.7-0.5-1-0.3c-0.7,0.4-1.2,1.1-1.6,1.6c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.2-0.8,0-1,0.4
		c-0.2,0.4,0,0.8,0.3,1c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.4,0.4,0.7,0.4s0.5-0.2,0.6-0.4c0,0,0.1-0.2,0.1-0.2
		c0.1-0.2,0.2-0.4,0.4-0.6C19,5.9,19.4,5.5,19.7,5.3z"
        />
        <path
          d="M20.2,11.9c-0.2,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.3-0.3,0.3h-3.4
		c-1.3,0-2.1,1-2.5,1.9c-0.3,0.6-0.9,1.1-2,1.1s-1.7-0.6-2-1.1c-0.4-0.8-1.3-1.9-2.5-1.9H3.6c-0.2,0-0.3-0.1-0.3-0.3
		c0-2.2,0-4.1,0.2-5.3c0.2-1.2,0.5-1.8,0.9-2.3c0.5-0.5,1.1-0.8,2.3-0.9c1.1-0.1,2.9-0.2,4.9-0.2c0.2,0,0.3,0,0.4-0.1
		C12,4.1,12.1,4,12.1,3.8c0.1-0.2,0.1-0.4,0.2-0.5c0.2-0.5,0.4-0.7,0.3-0.9c-0.1-0.1-0.3-0.1-0.8-0.1l-0.1,0c-2.2,0-3.9,0-5.3,0.2
		C5,2.6,3.8,3,2.9,3.9S1.6,6,1.4,7.4c-0.2,1.2-0.2,3.1-0.2,5.1l0,1.5c0,1.7,0,3.2,0.3,4.3c0.2,1.2,0.6,2.1,1.4,2.8
		c0.9,0.9,2,1.2,3.3,1.4c1.3,0.2,3.1,0.2,5.3,0.2h0.1c2.2,0,3.9,0,5.3-0.2c1.4-0.2,2.5-0.6,3.3-1.4c0.8-0.8,1.1-1.7,1.4-2.8
		c0.2-1.1,0.2-2.5,0.3-4.3l0-1.5c0-0.1,0-0.2,0-0.3c0-0.5,0-0.7-0.1-0.8c-0.1-0.1-0.4,0-0.9,0.3C20.6,11.7,20.4,11.8,20.2,11.9z"
        />
      </g>
    </svg>
  )
}

export const OperatorMenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle
        cx="12"
        cy="4.5"
        r="2.5"
      />
      <path d="m10.2 6.3-3.9 3.9" />
      <circle
        cx="4.5"
        cy="12"
        r="2.5"
      />
      <path d="M7 12h10" />
      <circle
        cx="19.5"
        cy="12"
        r="2.5"
      />
      <path d="m13.8 17.7 3.9-3.9" />
      <circle
        cx="12"
        cy="19.5"
        r="2.5"
      />
    </svg>
  )
}

export const OrderTableViewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="18"
        height="18"
        x="3"
        y="3"
        rx="2"
        ry="2"
      />
      <line
        x1="3"
        x2="21"
        y1="9"
        y2="9"
      />
      <line
        x1="3"
        x2="21"
        y1="15"
        y2="15"
      />
      <line
        x1="9"
        x2="9"
        y1="9"
        y2="21"
      />
      <line
        x1="15"
        x2="15"
        y1="9"
        y2="21"
      />
    </svg>
  )
}

export const HKRScheduleDataIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="7"
        height="9"
        x="3"
        y="3"
        rx="1"
      ></rect>
      <rect
        width="7"
        height="5"
        x="14"
        y="3"
        rx="1"
      ></rect>
      <rect
        width="7"
        height="9"
        x="14"
        y="12"
        rx="1"
      ></rect>
      <rect
        width="7"
        height="5"
        x="3"
        y="16"
        rx="1"
      ></rect>
    </svg>
  )
}

export const FactoryAccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className="lucide lucide-brick-wall-shield-icon lucide-brick-wall-shield"
    >
      <path d="M12 9v1.258" />
      <path d="M16 3v5.46" />
      <path d="M21 9.118V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5.75" />
      <path d="M22 17.5c0 2.499-1.75 3.749-3.83 4.474a.5.5 0 0 1-.335-.005c-2.085-.72-3.835-1.97-3.835-4.47V14a.5.5 0 0 1 .5-.499c1 0 2.25-.6 3.12-1.36a.6.6 0 0 1 .76-.001c.875.765 2.12 1.36 3.12 1.36a.5.5 0 0 1 .5.5z" />
      <path d="M3 15h7" />
      <path d="M3 9h12.142" />
      <path d="M8 15v6" />
      <path d="M8 3v6" />
    </svg>
  )
}

export const UserManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="18"
        height="18"
        x="3"
        y="3"
        rx="2"
      ></rect>
      <circle
        cx="12"
        cy="10"
        r="3"
      ></circle>
      <path d="M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"></path>
    </svg>
  )
}
export const BomSearchIcon = () => {
  return (	 
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44"/></svg>
)
}
export const ExitTenantIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
      <polyline points="16 17 21 12 16 7"></polyline>
      <line
        x1="21"
        y1="12"
        x2="9"
        y2="12"
      ></line>
    </svg>
  )
}

export const ProfileIcon = () => {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 24 24"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clipRule="evenodd"
        fill="currentColor"
        fillRule="evenodd"
      >
        <path d="m17.0386 16.126c-3.0811-1.8347-6.9962-1.8347-10.07738 0-.16791.1-.35189.2043-.5446.3137-.71261.4043-1.54463.8763-2.12472 1.4441-.36013.3525-.51364.6433-.5382.8679-.0195.1784.0256.4725.47623.9018 1.03585.9869 2.08842 1.5965 3.36087 1.5965h8.8183c1.2724 0 2.325-.6096 3.3608-1.5965.4507-.4293.4958-.7234.4763-.9018-.0246-.2246-.1781-.5154-.5382-.8679-.5801-.5678-1.4121-1.0398-2.1248-1.4441-.1927-.1094-.3767-.2137-.5446-.3137zm.7675-1.2888c.1163.0692.26.1503.4226.2421.7128.4021 1.7903 1.01 2.5285 1.7325.4617.4519.9003 1.0474.9801 1.777.0848.7758-.2537 1.5039-.9327 2.1508-1.1714 1.116-2.5772 2.0104-4.3955 2.0104h-8.8183c-1.81831 0-3.22409-.8944-4.39554-2.0104-.67902-.6469-1.01748-1.375-.93268-2.1508.07975-.7296.5184-1.3251.98007-1.777.73817-.7225 1.81568-1.3304 2.52849-1.7325.16267-.0918.30634-.1729.42266-.2421 3.55405-2.1163 8.0582-2.1163 11.6123 0z" />
        <path d="m11.9999 2.75c-2.07104 0-3.74997 1.67893-3.74997 3.75s1.67893 3.75 3.74997 3.75c2.0711 0 3.75-1.67893 3.75-3.75s-1.6789-3.75-3.75-3.75zm-5.24997 3.75c0-2.8995 2.35051-5.25 5.24997-5.25 2.8995 0 5.25 2.3505 5.25 5.25 0 2.89949-2.3505 5.25-5.25 5.25-2.89946 0-5.24997-2.35051-5.24997-5.25z" />
      </g>
    </svg>
  )
}

export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        fill="currentColor"
        d="M13.24 2c.47 0 .86.38.86.86v18.29c0 .47-.38.86-.86.86-5.89 0-10-4.11-10-10S7.36 2 13.24 2z"
        opacity=".4"
      ></path>
      <path
        fill="currentColor"
        d="M20.54 11.54L17.7 8.69a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06l1.56 1.56H8.63c-.41 0-.75.34-.75.75s.34.75.75.75h9.57l-1.56 1.56c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l2.84-2.85a.73.73 0 000-1.04z"
      ></path>
    </svg>
  )
}
export const DimensionIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-ruler-dimension-line-icon lucide-ruler-dimension-line"><path d="M10 15v-3" /><path d="M14 15v-3" /><path d="M18 15v-3" /><path d="M2 8V4" /><path d="M22 6H2" /><path d="M22 8V4" /><path d="M6 15v-3" /><rect x="2" y="12" width="20" height="8" rx="2" /></svg>
  )
}

export const CheckItemTemplateIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M13 5h8" /><path d="M13 12h8" /><path d="M13 19h8" /><path d="m3 17 2 2 4-4" /><rect x="3" y="4" width="6" height="6" rx="1" /></svg>

  );
};